import CloudUploadIcon from '@mui/icons-material/CloudUploadOutlined';
import { Icon } from '@mui/material';
import React from 'react';
import BaseDropzoneComponent from './BaseDropzoneComponent';
import Styles from './FileUploadDropzone.scss';
import { IBaseDropzoneComponentProps } from './Interfaces';

const FileUploadDropzone = (props: IBaseDropzoneComponentProps) => {
    const {
        outerContainerClassname,
        innerContainerClassname,
        actionTextClassname,
        ...dropzoneProps
    } = props;

    const outerClassname = outerContainerClassname
        ? outerContainerClassname
        : Styles.fuContainer;
    const innerClassname = innerContainerClassname
        ? innerContainerClassname
        : Styles.fuInnerContainer;
    const actionClassname = actionTextClassname
        ? actionTextClassname
        : Styles.fuActionText;

    return (
        <BaseDropzoneComponent
            id={props.id}
            outerContainerClassname={outerClassname}
            innerContainerClassname={innerClassname}
            {...dropzoneProps}
        >
            <React.Fragment>
                <span className={actionClassname}>
                    Drag and Drop files here
                </span>
                <Icon
                    sx={{
                        width: Styles.iconSize,
                        height: Styles.iconSize,
                        fontSize: Styles.iconSize,
                        color: '#fff',
                    }}
                >
                    <CloudUploadIcon style={{ fontSize: Styles.iconSize }} />
                </Icon>
                <span className={Styles.fuAdditionalText}>or</span>
                <span className={actionClassname}> Click to Browse Files</span>
            </React.Fragment>
        </BaseDropzoneComponent>
    );
};

export default FileUploadDropzone;
